import { Avatar as MaterialAvatar } from '@mui/material'

const Avatar = MaterialAvatar

export { Avatar }
